export const CLEAR_ALL_ORDER_SUMMARIES = 'CLEAR_ALL_ORDER_SUMMARIES';
export const UPDATE_SUMMARY_REPORT_REQUEST_PARAMS =
  'UPDATE_SUMMARY_REPORT_REQUEST_PARAMS';
export const GET_ALL_ORDER_SUMMARY_SUCCESSFUL =
  'GET_ALL_ORDER_SUMMARY_SUCCESSFUL';
export const HIDE_TEMPORARY_SUMMARY_REPORT_BANNER =
  'HIDE_TEMPORARY_SUMMARY_REPORT_BANNER';
export const SET_IS_REQUESTING_DATA = 'SET_IS_REQUESTING_DATA';
